import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";

import "assets/css/material-dashboard-react.css?v=1.4.1";

import indexRoutes from "routes/index.jsx";

/*
import { firestore, storage } from "initfb.js";

firestore.collection('states').orderBy('date', 'desc').limit(2).get().then(function (data) {
	var date = null;
	var last = null;
	var before = null;

	function round(value, precision) {
		var multiplier = Math.pow(10, precision || 0);
		return Math.round(value * multiplier) / multiplier;
	}

	function itemDownload(idx, refDoc) {
		refDoc.get().then(function (itemRef) {
			var item = itemRef.data();
			if (idx == 0) {
				date = item.date.toDate();
				last = item.state;
			} else if (idx == 1) {
				before = item.state;
			}

			if (last != null && before != null) {
				console.log(last);
				//document.getElementById('info').innerHTML = 'Poslední hodnota:' + last + ' <span id="diff">(rozdíl: ' + round(last - before, 1) + ')</span><br/><div id="photo"></div><br/>Měřeno dne:<br/>' + date.toLocaleDateString();
				var pathTh = 'photos/' + date.getFullYear()+'-'+(1+date.getMonth()).toLocaleString('en-US', {minimumIntegerDigits:2})+'-'+(date.getDate()).toLocaleString('en-US', {minimumIntegerDigits:2})+'sm.jpg';
				var ref = storage.ref(pathTh);
				ref.getDownloadURL().then(function(url){
					console.log(url);
					//var img = document.createElement('img');
					//img.src = url;
					//document.getElementById('photo').appendChild(img);
				});
			}
		});
	}

	for (var idx in data.docs) {
		itemDownload(parseInt(idx), data.docs[idx].ref);
	}
});
*/

ReactDOM.render(
  <HashRouter>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} component={prop.component} key={key} />;
      })}
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js